// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__22wdh","info_icon":"style_info_icon__TI5x-","info_block":"style_info_block__1dZNj","info_block__visable":"style_info_block__visable___Kl4X"};